import { createFileRoute, notFound } from "@tanstack/react-router";
export const Route = createFileRoute("/marketing")({ beforeLoad: () => { throw notFound(); } });